/* eslint-disable lingui/no-unlocalized-strings -- brand name only */
/**
 * BuilderLogo — the Apply Edge chevron-wedge mark + wordmark (builder v3).
 * Presentational. Pass `onClick` (or wrap in a router <Link>) at the call site.
 */
export type BuilderLogoProps = {
  showWordmark?: boolean;
  onClick?: () => void;
};

export const BuilderLogo = ({ showWordmark = true, onClick }: BuilderLogoProps) => {
  return (
    <button
      type="button"
      className="flex shrink-0 items-center gap-2"
      aria-label="Apply Edge"
      onClick={onClick}
    >
      <svg width={26} height={26} viewBox="0 0 64 64" fill="none" aria-hidden="true">
        <rect width="64" height="64" rx="14" fill="#4F46E5" />
        <path d="M18 18 L34 32 L18 46 L26 46 L46 32 L26 18 Z" fill="#FFFFFF" />
      </svg>
      {showWordmark ? (
        <span className="text-[15px] font-semibold tracking-tight text-foreground">Apply Edge</span>
      ) : null}
    </button>
  );
};
